
import Vue from 'vue';

interface Methods {
  scrollToElement: () => void;
}

export default Vue.extend<unknown, Methods, unknown, unknown>({
  methods: {
    scrollToElement() {
      const scrollToElement = window.document.getElementsByClassName('article')[0];
      if (scrollToElement) {
        scrollToElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
});
